import { render } from "./CommitsBarChart.vue?vue&type=template&id=06fe3e74&scoped=true"
import script from "./CommitsBarChart.vue?vue&type=script&lang=js"
export * from "./CommitsBarChart.vue?vue&type=script&lang=js"

import "./CommitsBarChart.vue?vue&type=style&index=0&id=06fe3e74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06fe3e74"]])

export default __exports__